import React, { useContext } from 'react';
import Layout from '../../engine/layout';
import { Form, Input, Typography } from 'antd';
import DataTable from '../../engine/widgets/DataTable';
import moment from 'moment';
import { Editor } from '@tinymce/tinymce-react';
import { AppContext } from '../../App';

const FooterWrapper = (props) => {
    const app = useContext(AppContext);

    return <Footer app={app} {...props} />;
}
class Footer extends Layout {
    constructor(props) {
        super(props);
        this.app = props.app;

        this.ready = false;

        this.state = {
            types: {},
            data: [],
            ctx: 1,
        }
    }

    componentDidMount() {
        this.app = this.props.app;

        this.fetchData();
    }

    componentDidUpdate() {
        this.app = this.props.app;
    }

    fetchData = async () => {
        const response = await this.app.fn.api.get( `admin/contentTypes`, 1, 100 );
        if (response.ok && response.status === 200) {
            this.setState({ types: { ...response.body.types } });
        }
    }

    content (layout = `desktop`) {
        if (layout === `desktop`) {
            return this.contentWide();
        }

        return this.contentMobile();
    }

    head() {
        return (
            <div style={{
                position: `absolute`,
                height: `max(25vh, 300px)`,
                top: 0,
                left: 0,
                right: 0,
            }}>
                <Typography.Title
                    level={2}
                    style={{
                        color: `#F3DD8E`,
                        fontSize: 36,
                        margin: `4vh 0 30px 0`,
                        textAlign: `center`
                    }}
                >
                    Saturs
                </Typography.Title>
            </div>
        );
    }

    contentMobile() {
        const formJsx = (
            <>
                <Form.Item name="key">
                    <Input disabled />
                </Form.Item>
                <Form.Item trigger="onEditorChange" rules={[{ required: true, message: `Ievadiet tekstu` }]} name="data">
                <Editor
                    apiKey="euipz64afb3zknqct64z4cr8asro9gz0ojcwb9skszyw8k3f"
                    init={{
                        plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss',
                        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                        tinycomments_mode: 'embedded',
                        tinycomments_author: 'Author name',
                        mergetags_list: [
                            { value: 'First.Name', title: 'First Name' },
                            { value: 'Email', title: 'Email' },
                        ],
                        ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                    }}
                    // initialValue="Welcome to TinyMCE!"
                />
                </Form.Item>
            </>
        );
        
        return (
            <>
                <div style={{ height: 50, width: `100%` }} />
                <DataTable
                    app={this.app}
                    source="admin/content"
                    key={`content-${this.state.ctx}`}
                    columns={[
                        {
                            title: `Nosaukums`,
                            key: `key`,
                        },
                        {
                            title: `Datums`,
                            key: `created_at`,
                            render: (val) => {
                                return moment(val).format(`DD.MM.YYYY HH:mm`);
                            },
                        },
                    ]}
                    onAdd={() => {
                        this.setState((old) => ({ ctx: old.ctx + 1 }));
                    }}
                    addForm={null}
                    editForm={formJsx}
                    modalStyle={{ minWidth: 650 }}
                />
            </>
        );
    }

    contentWide() {
        const formJsx = (
            <>
                <Form.Item name="key">
                    <Input disabled />
                </Form.Item>
                <Form.Item trigger="onEditorChange" rules={[{ required: true, message: `Ievadiet tekstu` }]} name="data">
                    <Editor
                        apiKey="euipz64afb3zknqct64z4cr8asro9gz0ojcwb9skszyw8k3f"
                        init={{
                            plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss',
                            toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                            tinycomments_mode: 'embedded',
                            tinycomments_author: 'Author name',
                            mergetags_list: [
                                { value: 'First.Name', title: 'First Name' },
                                { value: 'Email', title: 'Email' },
                            ],
                            ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                        }}
                        // initialValue="Welcome to TinyMCE!"
                    />
                </Form.Item>
            </>
        );
        
        return (
            <>
                <Typography.Title level={2}>Saturs</Typography.Title>
                <DataTable
                    app={this.app}
                    source="admin/content"
                    key={`content-${this.state.ctx}`}
                    columns={[
                        {
                            title: `Nosaukums`,
                            key: `key`,
                        },
                        {
                            title: `Datums`,
                            key: `created_at`,
                            render: (val) => {
                                return moment(val).format(`DD.MM.YYYY HH:mm`);
                            },
                        },
                    ]}
                    onAdd={() => {
                        this.setState((old) => ({ ctx: old.ctx + 1 }));
                    }}
                    addForm={null}
                    editForm={formJsx}
                    modalStyle={{ minWidth: 650 }}
                />
            </>
        );
    }
}

export default FooterWrapper;
